import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import ImpersonationBanner from "./components/common/ImpersonationBanner";
import ImpersonateUser from "./components/admin/impersonateUser";
import OrgAdmins from "./components/admin/orgAdmins";
import { AuthProvider } from "./context/AuthContext";
import PaymentBannerWrapper from "./components/payment/PaymentBannerWrapper";

// Protect Route
import ProtectedRoute from "./components/ProtectedRoute";
// Page Import
import ForgotPassword from "./components/pages/forgotPassword";
import ResetPassword from "./components/pages/resetPassword";
import ChangePassword from "./components/pages/changePassword";
import Profile from "./components/pages/profile";
import Login from "./components/pages/login";
import Unsubscribe from "./components/pages/unsubscribe";
import AdminPasswordResetExample from "./components/admin/AdminPasswordResetExample";
import SelectRegister from "./components/pages/register/selectregister";
import Register from "./components/pages/register";
import SchoolRegister from "./components/pages/register/schoolregister";
import SchoolEdit from "./components/pages/register/schooledit";
import TeacherRegister from "./components/pages/register/teacherregister";
import IndividualTeacherRegister from "./components/pages/register/individualteacherregister";
import Card from "./components/payment/card";
import PaymentPage from "./components/payment/PaymentPage";
import PaymentPageTest from "./components/payment/PaymentPageTest";
import UpdatePaymentInfoPage from "./components/payment/UpdatePaymentInfoPage";
import RenewCheckout from "./components/payment/RenewCheckout";

import NotFound from "./components/pages/error/notfound";

// Admin
import AdminDashboard from "./components/admin/dashboard";
import TeacherLists from "./components/admin/teacherList";
import SchoolLists from "./components/admin/schoolList";
import AdminTeacherQuizDashboard from "./components/admin/teacherQuizDashboard";
import SchoolTeacherList from "./components/admin/schoolTeacher";
import InfluenceList from "./components/admin/influenceList";
import PromoCodes from "./components/admin/promoCodes";
import DrawingEntries from "./components/admin/drawingEntries";
import React from "react";
// School
import SchoolOrderHistory from "./components/school/orderhistory";
import AddSchoolTeacher from "./components/school/teacher";
import AdministratorManagement from "./components/school/adminManagement";
import MyTeachers from "./components/school/myteachers";
import ViewAction from "./components/school/viewAction";
import EditTeacher from "./components/school/editTeacher"
import SchoolCertifications from "./components/school/certifications";
import SchoolAdminTeacherCertificationsDashboard from "./components/school/teacher-certifications-dashboard";
// School Teacher
import SchoolTeacherDashboard from "./components/schoolteacher/dashboard";
import SchoolTeacherCertifications from "./components/schoolteacher/certifications";

// Individual Teacher
import TeacherDashboard from "./components/teacher/dashboard";
import TeacherOrderHistory from "./components/teacher/orderhistory";
import TeacherCertifications from "./components/teacher/certifications";
import CompletedCertifications from "./components/certifications/CompletedCertifications";
import CertificationTracker from "./components/certifications/CertificationTracker";
import MainDashboard from "./components/dashboard/MainDashboard";
import TeacherTest from "./components/teachertest";
import Test from "./components/test";
import { Home } from "./components/home";
import {
  CertificateList,
  ViewCertificate,
  StaticCertificatetest,
  AutoDownloadCertificate,
} from "./components/certification";
import GrantApplications from "./components/admin/grantApplicationList";
import TestMegaMenu from "./components/admin/testMegaMenu";
import QuizBackdoor from "./components/admin/quizBackdoor";
import StateAdminDashboard from "./components/admin/state-dashboard";
import SchoolsList from "./components/state/SchoolsList";
import Analytics from "./components/state/Analytics";
import Reports from "./components/state/Reports";
import DevTools from "./components/devTools";
import CustomTrainingManagement from "./components/admin/customTraining/CustomTrainingManagement";
import CourseBuilder from "./components/admin/customTraining/CourseBuilder";
import CourseImportWizard from "./components/admin/customTraining/CourseImportWizard";
import CoursePlayer from "./components/customTraining/CoursePlayer";
import CourseCertificate from "./components/customTraining/CourseCertificate";
import CustomTrainingPDFViewer from "./components/customTraining/CustomTrainingPDFViewer";
import CustomTrainingQuiz from "./components/customTraining/CustomTrainingQuiz";

const Approuter = () => {
  return (
    <AuthProvider>
      {/* Sits above every route: an operator must never lose sight of the fact
          that they are viewing another user's account. */}
      <ImpersonationBanner />
      <BrowserRouter basename="/">
        <PaymentBannerWrapper>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/selectregister" element={<SelectRegister />} />
            <Route path="/register/:type" element={<Register />} />
            <Route path="/schoolregister/:type" element={<SchoolRegister />} />
            <Route path="/individualteacherregister" element={<IndividualTeacherRegister />} />
            <Route path="/schooledit/:school_id" element={<SchoolEdit />} />
            <Route path="/teacherregister/:type" element={<TeacherRegister />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/unsubscribe" element={<Unsubscribe />} />
            <Route path="/teachertest/mcq-test" element={<TeacherTest />} />
            <Route path="/test/mcq-test" element={<TeacherTest />} />
            <Route path="/admin/password-reset-test" element={<AdminPasswordResetExample />} />
            <Route path="/certificates" element={<CertificateList />} />
            <Route
              path="/all-certificates/:teacher_id"
              element={<CertificateList />}
            />
            <Route
              path="/viewcertificate/:userid/:type"
              element={<ViewCertificate />}
            />
            <Route
              path="/certificate/:userid/:type"
              element={<AutoDownloadCertificate />}
            />
            <Route
              path="/emergencycertificate/:userid"
              element={<StaticCertificatetest />}
            />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            {/* Test Payment Page - No authentication required */}
            <Route path="/test-payment" element={<PaymentPageTest />} />
            {/* <Route path="/card" element={<Card />} /> */}
            <Route element={<ProtectedRoute allowedRoles={["1", "3"]} />}>
              <Route path="/payment" element={<PaymentPage />} />
            </Route>
            <Route element={<ProtectedRoute allowedRoles={["admin"]} />}>
              <Route path="/admin/admin-dashboard" element={<AdminDashboard />} />
              <Route path="/admin/teachers-lists" element={<TeacherLists />} />
            </Route>
            <Route element={<ProtectedRoute allowedRoles={["4"]} />}>
              <Route path="/admin/state-dashboard" element={<StateAdminDashboard />} />
              <Route path="/state/schools" element={<SchoolsList />} />
              <Route path="/state/schools/search" element={<SchoolsList />} />
              <Route path="/state/analytics/:type?" element={<Analytics />} />
              <Route path="/state/reports/:type?" element={<Reports />} />
              <Route path="/state/stats" element={<StateAdminDashboard />} />
              <Route path="/state/export" element={<SchoolsList />} />
              <Route path="/state/search" element={<SchoolsList />} />
              <Route path="/state/updates" element={<StateAdminDashboard />} />
              <Route path="/state/weekly" element={<StateAdminDashboard />} />
            </Route>
            <Route element={<ProtectedRoute allowedRoles={["admin"]} />}>
              <Route
                path="/admin/school-teacher-list"
                element={<SchoolTeacherList />}
              />
              <Route
                path="/admin/school-teacher-list/:school_id"
                element={<SchoolTeacherList />}
              />
              <Route path="/admin/school-lists" element={<SchoolLists />} />
              <Route path="/admin/impersonate-user" element={<ImpersonateUser />} />
              <Route path="/admin/org-admins" element={<OrgAdmins />} />
              <Route path="/admin/teacher-quiz-dashboard" element={<AdminTeacherQuizDashboard />} />
              <Route path="/admin/influences" element={<InfluenceList />} />
              <Route path="/admin/promo-codes" element={<PromoCodes />} />
              <Route path="/admin/grant-applications" element={<GrantApplications />} />
              <Route path="/admin/drawing-entries" element={<DrawingEntries />} />
              <Route path="/admin/test-mega-menu" element={<TestMegaMenu />} />
              <Route path="/admin/quiz-backdoor" element={<QuizBackdoor />} />
              <Route path="/admin/custom-training" element={<CustomTrainingManagement />} />
              <Route path="/admin/custom-training/create" element={<CourseBuilder />} />
              <Route path="/admin/custom-training/import" element={<CourseImportWizard />} />
              <Route path="/admin/custom-training/edit/:id" element={<CourseBuilder />} />
            </Route>
            <Route element={<ProtectedRoute allowedRoles={["1"]} />}>
              <Route
                path="/school-order-history"
                element={<SchoolOrderHistory />}
              />
            </Route>
            <Route element={<ProtectedRoute allowedRoles={["1"]} />}>
              <Route
                path="/school-certifications"
                element={<SchoolCertifications />}
              />
            </Route>
            <Route element={<ProtectedRoute allowedRoles={["1", "3"]} />}>
              <Route
                path="/update-payment-info"
                element={<UpdatePaymentInfoPage />}
              />
              <Route path="/renew" element={<RenewCheckout />} />
            </Route>
            {/* Unified certification tracker for all roles (1, 2, 3) */}
            <Route element={<ProtectedRoute allowedRoles={["1", "2", "3"]} />}>
              <Route
                path="/my-certifications"
                element={<CertificationTracker />}
              />
            </Route>
            {/* Change Password - Available to all authenticated users */}
            <Route element={<ProtectedRoute allowedRoles={["admin", "1", "2", "3", "4"]} />}>
              <Route
                path="/change-password"
                element={<ChangePassword />}
              />
            </Route>
            {/* Profile - Available to all authenticated users */}
            <Route element={<ProtectedRoute allowedRoles={["admin", "1", "2", "3", "4"]} />}>
              <Route
                path="/profile"
                element={<Profile />}
              />
            </Route>
            {/* Dev Tools - Available to admin users only */}
            <Route element={<ProtectedRoute allowedRoles={["admin"]} />}>
              <Route
                path="/dev-tools"
                element={<DevTools />}
              />
            </Route>
            {/* Legacy routes - redirect to /my-certifications for backward compatibility */}
            <Route element={<ProtectedRoute allowedRoles={["2"]} />}>
              <Route
                path="/schoolteacher-certifications"
                element={<Navigate to="/my-certifications" replace />}
              />
            </Route>
            <Route element={<ProtectedRoute allowedRoles={["3"]} />}>
              <Route
                path="/teacher-certifications"
                element={<Navigate to="/my-certifications" replace />}
              />
            </Route>
            <Route element={<ProtectedRoute allowedRoles={["1"]} />}>
              <Route path="/add-school-teacher" element={<AddSchoolTeacher />} />
            </Route>
            <Route element={<ProtectedRoute allowedRoles={["1"]} />}>
              <Route path="/my-teachers" element={<MyTeachers />} />
            </Route>
            <Route element={<ProtectedRoute allowedRoles={["1"]} />}>
              <Route path="/editTeacher" element={<EditTeacher />} />
            </Route>
            <Route element={<ProtectedRoute allowedRoles={["1"]} />}>
              <Route path="/viewaction" element={<ViewAction />} />
            </Route>
            <Route element={<ProtectedRoute allowedRoles={["1"]} />}>
              <Route path="/teacher-certifications-dashboard" element={<SchoolAdminTeacherCertificationsDashboard />} />
            </Route>
            <Route element={<ProtectedRoute allowedRoles={["1"]} />}>
              <Route path="/administrator-management" element={<AdministratorManagement />} />
            </Route>
            <Route element={<ProtectedRoute allowedRoles={["2"]} />}>
              <Route
                path="/schoolteacher-dashboard"
                element={<SchoolTeacherDashboard />}
              />
            </Route>
            <Route element={<ProtectedRoute allowedRoles={["3"]} />}>
              <Route path="/teacher-dashboard" element={<TeacherDashboard />} />
            </Route>
            <Route element={<ProtectedRoute allowedRoles={["3"]} />}>
              <Route
                path="/teacher-order-history"
                element={<TeacherOrderHistory />}
              />
            </Route>
            {/* Unified certifications page for all teacher types (School Admin, School Teacher, Individual Teacher) */}
            <Route element={<ProtectedRoute allowedRoles={["1", "2", "3"]} />}>
              <Route
                path="/completed-certifications"
                element={<CompletedCertifications />}
              />
            </Route>
            {/* Unified main dashboard for all teacher types (School Admin, School Teacher, Individual Teacher, Admin) */}
            <Route element={<ProtectedRoute allowedRoles={["admin", "1", "2", "3"]} />}>
              <Route
                path="/main-dashboard"
                element={<MainDashboard />}
              />
            </Route>
            {/* Custom Training PDF Viewer - Available to all authenticated users */}
            <Route element={<ProtectedRoute allowedRoles={["admin", "1", "2", "3"]} />}>
              <Route path="/custom-training/course/:courseId" element={<CoursePlayer />} />
              <Route path="/custom-training/certificate/:courseId" element={<CourseCertificate />} />
              <Route
                path="/custom-training/pdf/:courseId"
                element={<CustomTrainingPDFViewer />}
              />
            </Route>
            {/* Custom Training Quiz - Available to all authenticated users */}
            <Route element={<ProtectedRoute allowedRoles={["admin", "1", "2", "3"]} />}>
              <Route
                path="/custom-training/quiz/:courseId"
                element={<CustomTrainingQuiz />}
              />
            </Route>
            <Route path="*" element={<NotFound />} />
          </Routes>
        </PaymentBannerWrapper>
      </BrowserRouter>
    </AuthProvider>
  );
};

export default Approuter;
